<div class="p-4" *ngIf="canView; else noPermission">
  <h2 class="mt-0">{{ 'sidebar.business_center.fefo_violation' | translate }}</h2>
  <div class="flex gap-2 mb-3 flex-wrap align-items-center">
    <input
      pInputText
      [(ngModel)]="skuCode"
      [placeholder]="'stock.fefo.sku' | translate"
      (keyup.enter)="search()"
    />
    <input
      pInputText
      type="number"
      [(ngModel)]="warehouseId"
      [placeholder]="'stock.fefo.warehouse' | translate"
      (keyup.enter)="search()"
    />
    <button pButton type="button" [label]="'lot_trace.search' | translate" (click)="search()"></button>
  </div>

  <p-table [value]="rows" [loading]="loading" [paginator]="false">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'stock.fefo.sku' | translate }}</th>
        <th>{{ 'stock.fefo.warehouse' | translate }}</th>
        <th>{{ 'stock.fefo.suggested_lot' | translate }}</th>
        <th>{{ 'stock.fefo.chosen_lot' | translate }}</th>
        <th>{{ 'stock.fefo.quantity' | translate }}</th>
        <th>{{ 'stock.fefo.reason' | translate }}</th>
        <th>{{ 'stock.fefo.actor' | translate }}</th>
        <th>{{ 'stock.fefo.created_at' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.skuCode }}</td>
        <td>{{ row.warehouseId }}</td>
        <td>{{ row.suggestedBatchId }} ({{ row.suggestedExpiryDate }})</td>
        <td>{{ row.chosenBatchId }} ({{ row.chosenExpiryDate }})</td>
        <td>{{ row.quantity }}</td>
        <td>{{ row.reason }}</td>
        <td>{{ row.actor }}</td>
        <td>{{ row.creationDate | date: 'short' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">{{ 'lot_trace.empty' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-template #noPermission>
  <div class="p-4">{{ 'common.permissions.no_permission' | translate }}</div>
</ng-template>
